/**
 * Web Vitals Integration
 * Reports Core Web Vitals to analytics
 */

import { onCLS, onLCP, onTTFB, onINP } from 'web-vitals';
import type { Metric } from 'web-vitals';
import { analytics } from './analytics';

/**
 * Initialize Web Vitals reporting
 */
export function initWebVitals(): void {
  const sendToAnalytics = (metric: Metric) => {
    analytics.trackWebVital(metric.name, metric.value, metric.rating);
  };

  // Core Web Vitals (2024 standard)
  onCLS(sendToAnalytics);   // Cumulative Layout Shift
  onLCP(sendToAnalytics);   // Largest Contentful Paint
  onINP(sendToAnalytics);   // Interaction to Next Paint
  
  // Additional metrics
  onTTFB(sendToAnalytics);  // Time to First Byte
}

/**
 * Get current performance metrics
 */
export function getPerformanceMetrics(): Record<string, number> {
  const navigation = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming;
  
  if (!navigation) {return {};}

  return {
    dns: navigation.domainLookupEnd - navigation.domainLookupStart,
    tcp: navigation.connectEnd - navigation.connectStart,
    ttfb: navigation.responseStart - navigation.requestStart,
    download: navigation.responseEnd - navigation.responseStart,
    domInteractive: navigation.domInteractive - navigation.fetchStart,
    domComplete: navigation.domComplete - navigation.fetchStart,
    loadComplete: navigation.loadEventEnd - navigation.fetchStart,
  };
}
